import { render, staticRenderFns } from "./textBoxMatchMaking.vue?vue&type=template&id=199daaf2&scoped=true&"
import script from "./textBoxMatchMaking.vue?vue&type=script&lang=js&"
export * from "./textBoxMatchMaking.vue?vue&type=script&lang=js&"
import style0 from "./textBoxMatchMaking.vue?vue&type=style&index=0&id=199daaf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199daaf2",
  null
  
)

export default component.exports